(function () {
  'use strict';
  var OWN = '_ss_charm_spend_gift';
  var CODES = ['STORYGIFT100', 'STORYGIFT250', 'STORYGOLD100', 'STORYGOLD250'];
  var ORDER = '_ss_storyline_gift_order';
  var DECLINED = '_ss_storyline_gift_declined';
  function declineAttributes(value){var attrs={};attrs[DECLINED]=value?'1':'';return attrs;}
  function resetConsent(cart){return (cart.items||[]).some(eligible)||!(cart.attributes||{})[DECLINED]?{}:declineAttributes(false);}
  var cachedConfigElement,cachedConfigText,cachedConfig;
  function active() { return true; }
  function config() {
    var el=document.querySelector('[data-ss-charm-gift-config]');
    if(!el)return null;
    var raw=el.textContent;if(el===cachedConfigElement&&raw===cachedConfigText)return cachedConfig;
    try{cachedConfig=JSON.parse(raw);cachedConfigElement=el;cachedConfigText=raw;return cachedConfig;}catch(_){return null;}
  }
  function owned(item) { var c=config(),ids=[51725363740918,51725363839222,51725363937526,51725364035830].concat((c&&c.rewards||[]).map(function(r){return Number(r.id);}));return !!(item.properties || {})[OWN] && ids.indexOf(Number(item.variant_id))!==-1; }
  function eligible(item) { return !owned(item); }
  function identity(item) {
    var props=item.properties||{},pairs=Object.keys(props).sort().filter(function(k){return props[k]!==null&&props[k]!=='';}).map(function(k){return [k,String(props[k])];});
    var plan=item.selling_plan_allocation;
    var value=JSON.stringify([Number(item.variant_id),plan&&plan.selling_plan&&plan.selling_plan.id||item.selling_plan||0,pairs]);
    var a=2166136261,b=3339675911;
    for(var n=0;n<value.length;n++){a=Math.imul(a^value.charCodeAt(n),16777619);b=Math.imul(b^value.charCodeAt(n),2246822519);}
    return (a>>>0).toString(36)+'.'+(b>>>0).toString(36);
  }
  function savedOrder(cart) {
    try{var order=JSON.parse((cart.attributes||{})[ORDER]||'[]');return Array.isArray(order)?order.filter(function(k){return typeof k==='string';}):[];}catch(_){return [];}
  }
  function chronological(cart,context) {
    var items=(cart.items||[]).filter(eligible),present=items.map(identity),order=savedOrder(cart),seen={};
    if(!order.length&&context&&context.previous)order=chronological(context.previous);
    var result=order.filter(function(k){if(present.indexOf(k)<0||seen[k])return false;seen[k]=true;return true;});
    var candidates=((context&&context.added)||[]).filter(eligible).concat(items.slice().reverse());
    candidates.forEach(function(item){var key=identity(item);if(present.indexOf(key)>=0&&!seen[key]){seen[key]=true;result.push(key);}});
    return result;
  }
  function materialFamily(item) {
    var options=item.options_with_values||[],props=item.properties||{};
    var material=options.find(function(o){return String(o.name).trim().toLowerCase()==='material';});
    var key=Object.keys(props).find(function(k){return k.trim().toLowerCase()==='material';});
    var value=String(material?material.value:key?props[key]:'').trim().toLowerCase().replace(/\s+/g,' ');
    if(['silver plated','925 sterling silver','white gold vermeil','18k white gold vermeil'].indexOf(value)>=0)return 'silver';
    if(['18k gold plated','18k gold vermeil','18k rose gold vermeil'].indexOf(value)>=0)return 'gold';
    return null;
  }
  function family(cart,order) {
    var items=(cart.items||[]).filter(eligible);
    for(var n=0;n<order.length;n++){
      var item=items.find(function(i){return identity(i)===order[n];});
      var selected=item&&materialFamily(item);if(selected)return selected;
    }
    return 'silver';
  }
  function giftFor(c,selected,tier) {
    if(!tier)return null;
    var gift=(c.rewards||[]).find(function(g){return g.family===selected&&Number(g.tier)===tier;});
    if(gift)return gift;
    if(selected!=='silver')return null;
    var old=c.gifts&&c.gifts[String(tier)];
    return old?Object.assign({code:'STORYGIFT'+tier,material:tier===100?'Silver Plated':'925 Sterling Silver'},old):null;
  }
  function state(cart) {
    var rate = cart.currency === 'USD' ? 1 : Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
    if(!Number.isFinite(rate)||rate<=0)return {supported:false,spend:0,tier:0};
    var spend=(cart.items||[]).reduce(function(sum,item){return sum+(eligible(item)?Number(item.original_line_price)||0:0);},0);
    var low=Math.round(10000*rate),high=Math.round(25000*rate),order=chronological(cart);
    return {supported:true,spend:spend,low:low,high:high,family:family(cart,order),order:order,declined:(cart.attributes||{})[DECLINED]==='1',tier:spend>=high?250:spend>=low?100:0};
  }
  function codeList(cart) { return (cart.discount_codes||[]).map(function(d){return d.code;}); }
  function earlyChristmas(cart) { return window.SSEarlyChristmasEntry === true || codeList(cart).some(function(code){return String(code).toUpperCase()==='EC70-WELCOME-9C6F2A';}); }
  async function reconcileEarlyChristmas(snapshot,io) {
    if(window.SSEarlyChristmasReady)await window.SSEarlyChristmasReady;
    var cart=await io.read(),updates={},body={},changed=false;
    (cart.items||[]).filter(owned).forEach(function(item){updates[item.key]=0;});
    if(Object.keys(updates).length)body.updates=updates;
    if(codeList(cart).some(function(code){return CODES.indexOf(code)>=0;}))body.discount=codeList(cart).filter(function(code){return CODES.indexOf(code)<0;}).join(',');
    if(Object.keys(body).length){cart=await (io.renderedPost||io.post)('cart/update.js?customily_upsell=1',body);changed=true;}
    return {cart:cart,changed:changed,renderChanged:displaySignature(snapshot)!==displaySignature(cart)};
  }
  function money(cents,cart) { return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cart.currency||'USD',maximumFractionDigits:cents%100?2:0}).format(cents/100); }
  function interpolate(s,vars) { return String(s||'').replace(/\{(\w+)\}/g,function(_,key){return vars[key]===undefined?'':String(vars[key]);}); }
  function view(cart) {
    var c=config(); if(!c||!cart)return;
    var s=state(cart);
    document.querySelectorAll('[data-ss-charm-gift]').forEach(function(el){
      el.hidden=!active()||!s.supported||!cart.item_count||earlyChristmas(cart);
      if(el.hidden)return;
      var title=el.querySelector('[data-gift-message]'),progress=el.querySelector('[role="progressbar"]'),fill=el.querySelector('[data-gift-fill]');
      var gift=giftFor(c,s.family,s.tier),higher=giftFor(c,s.family,250);
      var free=gift&&(cart.items||[]).some(function(i){return owned(i)&&Number(i.variant_id)===gift.id && (i.line_level_discount_allocations||[]).some(function(a){return a.discount_application && a.discount_application.title===gift.code && Number(a.amount)>=Number(i.original_price);});});
      var text=s.tier===250 ? interpolate(free?c.text.unlockedMaterial:c.text.addingMaterial,{material:gift&&gift.material}) : s.tier===100 ? (free?interpolate(c.text.nextMaterial,{amount:money(Math.max(0,s.high-s.spend),cart),material:higher&&higher.material}):interpolate(c.text.addingMaterial,{material:gift&&gift.material})) : interpolate(c.text.next100,{amount:money(Math.max(0,s.low-s.spend),cart)});
      if(s.tier&&(!gift||!gift.available))text=c.text.unavailable;
      if(s.declined)text=c.text.declined;
      var accept=el.querySelector('[data-ss-gift-accept]');if(accept){accept.hidden=!s.declined||!s.tier||!gift||!gift.available;accept.textContent=c.text.accept;}
      title.textContent=text;
      progress.setAttribute('aria-valuenow',String(Math.min(s.high,s.spend)));progress.setAttribute('aria-valuemax',String(s.high));progress.setAttribute('aria-valuetext',text);
      fill.style.width=Math.min(100,s.spend/s.high*100)+'%';
      el.querySelector('[data-gift-low]').textContent=interpolate(c.text.spend,{amount:money(s.low,cart)});
      el.querySelector('[data-gift-high]').textContent=interpolate(c.text.spend,{amount:money(s.high,cart)});
      el.querySelector('[data-gift-low]').classList.toggle('is-earned',s.tier>=100);
      el.querySelector('[data-gift-high]').classList.toggle('is-earned',s.tier===250);
      el.querySelectorAll('[data-gift-tier]').forEach(function(card){
        var tier=Number(card.dataset.giftTier),current=s.tier===tier;
        card.classList.toggle('is-current',current);
        card.querySelector('.ss-charm-gift__earned').hidden=!current||!free;
        var retail=card.querySelector('[data-gift-retail]');
        var reward=giftFor(c,s.family,tier);
        if(reward){
          if(retail)retail.textContent=money(reward.price,cart);
          card.querySelector('.ss-charm-gift__material').textContent=reward.material;
          var zoom=card.querySelector('.ss-charm-gift__zoom'),img=zoom&&zoom.querySelector('img');
          if(zoom&&reward.large){zoom.dataset.image=reward.large;zoom.dataset.productTitle=reward.caption;zoom.setAttribute('aria-label',reward.viewLabel||reward.caption);}
          if(img&&reward.image){img.removeAttribute('srcset');img.src=reward.image;img.alt=reward.caption;}
        }
      });
      el.querySelector('[data-gift-value]').textContent=c.text.terms;
    });
    document.querySelectorAll('[data-ss-cart-key],.ink-cart-row').forEach(function(row){
      var key=row.dataset.ssCartKey||row.dataset.itemKey;
      var item=(cart.items||[]).find(function(i){return i.key===key;});
      if(!item||!owned(item))return;
      row.classList.add('ss-charm-gift-line');
      row.querySelectorAll('[data-ss-cart-step],[data-ss-cart-quantity],.quantity').forEach(function(el){el.hidden=true;});
      row.querySelectorAll('cart-remove-button,[data-ss-cart-remove]').forEach(function(el){el.hidden=false;el.setAttribute('aria-label',c.text.remove);});
      var price=row.querySelector('.ss-drawer-item__price strong');
      if(price&&item.final_price===0)price.textContent=c.text.free;
    });
  }
  function displaySignature(cart) {
    return JSON.stringify([cart.total_price,cart.item_count,(cart.items||[]).map(function(i){return [i.key,i.quantity,i.original_line_price,i.final_line_price,(i.line_level_discount_allocations||[]).map(function(a){return [Number(a.amount),a.discount_application&&a.discount_application.title];})];}),(cart.cart_level_discount_applications||[]).map(function(a){return [a.title,a.total_allocated_amount];})]);
  }
  function freeReward(cart,gift) {
    return (cart.items||[]).some(function(item){return owned(item)&&Number(item.variant_id)===gift.id&&item.quantity===1&&Number(item.final_line_price)===0&&(item.line_level_discount_allocations||[]).some(function(a){return a.discount_application&&a.discount_application.title===gift.code&&Number(a.amount)>=Number(item.original_price);});});
  }
  async function reconcileAutomatic(snapshot,io,context,c) {
    var cart=context&&context.freshSnapshot&&snapshot&&Array.isArray(snapshot.items)?snapshot:await io.read();
    var order=chronological(cart,context),attributes=resetConsent(cart),stored=(cart.attributes||{})[ORDER]||'',serialized=JSON.stringify(order),changed=false;
    if((order.length||stored)&&serialized!==stored&&stored!==(order.length?serialized:''))attributes[ORDER]=order.length?serialized:'';
    var projected=Object.assign({},cart,{attributes:Object.assign({},cart.attributes||{},attributes)});
    var s=state(projected),gift=s.declined?null:giftFor(c,s.family,s.tier),updates={},keep=false,body={},post=io.renderedPost||io.post;
    (cart.items||[]).filter(owned).forEach(function(item){
      if(gift&&gift.available&&!keep&&Number(item.variant_id)===gift.id){keep=true;if(item.quantity!==1)updates[item.key]=1;}
      else updates[item.key]=0;
    });
    if(Object.keys(updates).length)body.updates=updates;
    if(Object.keys(attributes).length)body.attributes=attributes;
    if(gift&&gift.available&&codeList(cart).length)body.discount='';
    else if(!gift&&codeList(cart).some(function(code){return CODES.indexOf(code)>=0;}))body.discount=codeList(cart).filter(function(code){return CODES.indexOf(code)<0;}).join(',');
    if(Object.keys(body).length){cart=await (gift&&gift.available&&!keep?io.post:post)('cart/update.js?customily_upsell=1',body);changed=true;}
    if(gift&&gift.available&&!keep){
      var response=await post('cart/add.js?customily_upsell=1',{items:[{id:gift.id,quantity:1,properties:{_ss_charm_spend_gift:s.family+':'+s.tier}}]});
      cart=io.cartFromResponse&&io.cartFromResponse(response)||await io.read();changed=true;
    }
    if(gift&&gift.available&&!freeReward(cart,gift)){
      cart=await post('cart/update.js?customily_upsell=1',{discount:''});changed=true;
      if(!freeReward(cart,gift)){
        updates={};(cart.items||[]).filter(owned).forEach(function(item){updates[item.key]=0;});
        if(Object.keys(updates).length)await io.update(updates);
        throw new Error(c.text.failure);
      }
    }
    return {cart:cart,changed:changed,renderChanged:displaySignature(snapshot)!==displaySignature(cart)};
  }
  async function reconcile(snapshot,io,context) {
    if(!active())return {cart:snapshot,changed:false,renderChanged:false};
    var c=config();if(!c)return {cart:snapshot,changed:false,renderChanged:false};
    if(earlyChristmas(snapshot))return reconcileEarlyChristmas(snapshot,io);
    if(c.mode==='automatic')return reconcileAutomatic(snapshot,io,context,c);
    var reusable=context&&context.freshSnapshot&&snapshot&&Array.isArray(snapshot.items);
    var cart=reusable?snapshot:await io.read();
    if(reusable&&!Array.isArray(cart.discount_codes)&&(cart.items||[]).some(owned))cart=await io.read();
    var changed=false,order=chronological(cart,context),attributes=resetConsent(cart);
    var serialized=JSON.stringify(order),stored=(cart.attributes||{})[ORDER]||'';
    if((order.length||stored)&&serialized!==stored&&stored!==(order.length?serialized:''))attributes[ORDER]=order.length?serialized:'';
    var projected=Object.assign({},cart,{attributes:Object.assign({},cart.attributes||{},attributes)});
    var s=state(projected),gift=s.declined?null:giftFor(c,s.family,s.tier),updates={};
    var keep=false,added=false;
    (cart.items||[]).filter(owned).forEach(function(i){
      if(gift&&gift.available&&!keep&&Number(i.variant_id)===gift.id){keep=true;if(i.quantity!==1)updates[i.key]=1;}
      else updates[i.key]=0;
    });
    if(Object.keys(updates).length){cart=await io.update(updates);changed=true;}
    var expected=gift&&gift.available?gift.code:null;
    if(expected&&!keep){
      await io.post('cart/add.js?customily_upsell=1',{items:[{id:gift.id,quantity:1,properties:{_ss_charm_spend_gift:s.family+':'+s.tier}}]});
      added=true;changed=true;
    }
    var current=codeList(cart),body={};
    if(Object.keys(attributes).length)body.attributes=attributes;
    if(expected&&(added||current.length!==1||current[0]!==expected||!(cart.discount_codes||[]).some(function(d){return d.code===expected&&d.applicable;})))body.discount=expected;
    else if(!expected&&current.some(function(code){return CODES.indexOf(code)>=0;}))body.discount=current.filter(function(code){return CODES.indexOf(code)<0;}).join(',');
    if(Object.keys(body).length){cart=await io.post('cart/update.js?customily_upsell=1',body);changed=true;}
    if(!expected&&body.discount===undefined&&codeList(cart).some(function(code){return CODES.indexOf(code)>=0;})){
      cart=await io.post('cart/update.js?customily_upsell=1',{discount:codeList(cart).filter(function(code){return CODES.indexOf(code)<0;}).join(',')});changed=true;
    }
    if(expected){
      var reward=(cart.items||[]).filter(function(i){return owned(i)&&Number(i.variant_id)===gift.id;});
      var applied=reward.some(function(i){return (i.line_level_discount_allocations||[]).some(function(a){return a.discount_application&&a.discount_application.title===expected&&Number(a.amount)>=Number(i.original_price);});});
      if(!applied){
        updates={};(cart.items||[]).filter(owned).forEach(function(i){updates[i.key]=0;});
        if(Object.keys(updates).length)await io.update(updates);
        throw new Error(c.text.failure);
      }
    }
    return {cart:cart,changed:changed,renderChanged:displaySignature(snapshot)!==displaySignature(cart)};
  }
  var checkoutPending=false,checkoutReady=false;
  document.addEventListener('submit',function(event){
    var button=event.submitter,form=event.target,api=window.SoulyshineDrawer;
    if(window.SoulyshineEngraving&&window.SoulyshineEngraving.handlesGiftCheckout)return;
    if(checkoutReady||!active()||!api||!button||button.name!=='checkout'||!form.matches('#cart,#CartDrawer-Form'))return;
    event.preventDefault();event.stopImmediatePropagation();
    if(checkoutPending)return;
    checkoutPending=true;
    var id=button.id;
    api.refresh(false).then(function(){
      var current=document.getElementById(id);
      if(current&&current.form&&!current.disabled){
        checkoutReady=true;
        try{current.form.requestSubmit(current);}finally{checkoutReady=false;}
      }
    }).catch(function(){}).finally(function(){checkoutPending=false;});
  },true);
  document.addEventListener('soulyshine:cart:updated' ,function(e){view(e.detail&&e.detail.cart);});
  document.addEventListener('click',function(event){
    var button=event.target.closest&&event.target.closest('[data-ss-gift-accept]'),api=window.SoulyshineDrawer;
    if(!button||button.disabled||!api||!api.setGiftConsent)return;
    event.preventDefault();api.setGiftConsent(false).catch(function(){});
  });
  function boot(){var api=window.SoulyshineDrawer;if(active()&&api)api.refresh(false).catch(function(){});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(boot,0);},{once:true});else setTimeout(boot,0);
  window.SSCharmGift={active:active,state:state,owned:owned,declineAttributes:declineAttributes,view:view,reconcile:reconcile};
})();
